export default function OpenContactWidget() {
    window.FreshworksWidget('open');
}
